/**
 * Content format versioning (A-39, review S-3).
 *
 * Every content document (seed, level manifest, content index) carries an
 * integer `formatVersion`. Newer versions than this build supports are rejected
 * with a clear error instead of being half-understood. Upgraders for older
 * versions will be added here when version 2 exists.
 */

export function checkFormatVersion(doc: unknown, supported: number, label: string): void {
  const version =
    typeof doc === "object" && doc !== null
      ? (doc as { formatVersion?: unknown }).formatVersion
      : undefined;

  if (version === undefined) throw new Error(`${label}: missing formatVersion`);
  if (typeof version !== "number" || !Number.isInteger(version)) {
    throw new Error(`${label}: formatVersion must be an integer`);
  }
  if (version > supported) {
    throw new Error(`${label}: formatVersion ${version} is newer than supported (${supported})`);
  }
}
